import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import ChevronDownIcon from '../../../assets/icons/chevron-down.svg?react';
import { useSetUpList } from '../../../hooks/queries/setUpQueries';
import { ROUTES } from '../../../utils/constants';
const DrHistoryTableItem = ({ item, drSettlement, index }) => {
  const navigate = useNavigate();
  const { data: setUpData } = useSetUpList();
  const defaultCblModuleName = setUpData?.Items?.find(item => item.Group === 'DefaultCBL' && item.Key === 'DEFAULT_MODULE_NAME')?.Value;
  const defaultCblModuleVersion = setUpData?.Items?.find(item => item.Group === 'DefaultCBL' && item.Key === 'DEFAULT_MODULE_VERSION')?.Value;
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  }

  const handleNavigateToDetail = (e) => {
    e.stopPropagation();
    const targetDate = dayjs(item.date).format('YYYY-MM-DD');
    const startEndTime = `${item.startTime.replace(':', '')}-${item.endTime.replace(':', '')}`;
    const params = new URLSearchParams({ targetDate, startEndTime });
    navigate(`${ROUTES.DR_HISTORY_DETAIL}?${params.toString()}`, {
      state: { from: 'list' },
    });
  };

  const getDuration = (startTime, endTime) => {
    // HH:MM 형태의 문자열을 파싱
    const [startHour, startMinute] = startTime.split(':').map(Number);
    const [endHour, endMinute] = endTime.split(':').map(Number);
    
    // endTime에서 startTime을 빼기
    let durationHour = endHour - startHour;
    let durationMinute = endMinute - startMinute;
    
    // 분이 음수인 경우 시간에서 빼기
    if (durationMinute < 0) {
      durationHour--;
      durationMinute += 60;
    }
    
    return `${durationHour.toString().padStart(2, '0')}:${durationMinute.toString().padStart(2, '0')}`;
  }
  
  return (
    <>
      <tr key={item.id || index} onClick={handleExpand} className='primary-table-item-clickable'>
        <td><ChevronDownIcon className="cursor-pointer" style={{ transform: isExpanded ? 'rotate(-180deg)' : 'rotate(0deg)', transition: 'transform 0.2s ease' }} /></td>
        <td>{item.date}</td>
        <td>{item.startTime}</td>
        <td>{item.endTime}</td>
        <td>{getDuration(item.startTime, item.endTime)}</td>
        <td>
          <p
            className='text-c1-400 text-gray-600 cursor-pointer text-underline'
            onClick={handleNavigateToDetail}
          >
            부가정보 보기
          </p>
        </td>
      </tr>
      {isExpanded && (
        <tr>
          <td colSpan="6" className='expand-td'>
            <div className='sub-table'>
              <table>
                <thead>
                  <tr>
                    <th>DR 자원 이름</th>
                    <th>사용량(kWh)</th>
                    <th>CBL 값(kWh)</th>
                    <th>감축량(kWh)</th>
                    <th>예상 최소 정산 금액 (원)</th>
                    <th>예상 최대 정산 금액 (원)</th>
                    <th>알고리즘</th>
                    <th>버전</th>
                  </tr>
                </thead>
                <tbody>
                  {drSettlement?.map((drResource, index) => (
                    <tr key={index}>
                      <td>{drResource?.DrResourceName}</td>
                      <td>{drResource?.UsageValue || drResource?.UsageValue === 0 ? drResource?.UsageValue.toLocaleString() : '-'}</td>
                      <td>{drResource?.CblValue || drResource?.CblValue === 0 ? drResource?.CblValue.toLocaleString() : '-'}</td>
                      <td>{(drResource?.CblValue - drResource?.UsageValue) || (drResource?.CblValue - drResource?.UsageValue) === 0 ? (drResource?.CblValue - drResource?.UsageValue).toFixed(2).toLocaleString() : '-'}</td>
                      <td>{drResource?.MinSettlementAmount || drResource?.MinSettlementAmount === 0 ? drResource?.MinSettlementAmount.toLocaleString() : '-'}</td>
                      <td>{drResource?.MaxSettlementAmount || drResource?.MaxSettlementAmount === 0 ? drResource?.MaxSettlementAmount.toLocaleString() : '-'}</td>
                      <td>{drResource?.AppliedCblAlgorithm || `(기본) ${defaultCblModuleName}`}</td>
                      <td>{drResource?.AppliedCblAlgorithmVersion || `${defaultCblModuleVersion}`}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      )}
    </>
  )
}

export default DrHistoryTableItem